import { OnInit, Component, Input, ViewChild } from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DashboardService} from 'src/app/core/services/dashboard/dashboard.service';
import {UserService} from 'src/app/core/user/user.service';
import {UTILS} from "../../../../core/const/const";

@Component({
  selector: 'app-modal-evaluation',
  templateUrl: './modal-evaluation.component.html',
  styleUrls: ['./modal-evaluation.component.scss'],
})
export class ModalEvaluationComponent implements OnInit {
  @Input() bien: any;
  @Input() visite: any;
  @Input() colorIcon = 'white';

  @Input() hiddeButton = false;

  @Input() readOnly: any = false;

  @ViewChild('contentRating') contentRating: any;

  currentRate = 0;
  emptyReport = false;

  userConnected?: any = {};
  questionsData: any;
  isLoadedHttp = false;
  localMarket: any;
  launchedRequest = false;

  messageConfirmation: any = '';
  statusConfirmation = 'success';
  showAlert = false;

  public typeOfEvaluation: string = 'compte-rendu';
  evaluations: any;
  evaluations_questions: any = [];

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService,
    private _dashboardService: DashboardService
  ) {
  }

  ngOnInit() {
    this.userConnected = this._userService.getUser();
    if (!this.readOnly) {
      this.getQuesions(false);
    }
    if (this.hiddeButton) {
      setTimeout(() => {
        this.openVertically(this.contentRating);
      }, 100);
    }
  }

  openVertically(content: any) {
    this.modalService.dismissAll();
    this.showAlert = false;
    this.messageConfirmation = '';
    this.modalService.open(content, {size: 'xl'});
  }

  getQuesions(isKeysitter: boolean) {
    if (!isKeysitter) {
      this._dashboardService
        //.getQuestions(8357)
        .getQuestions(this.visite.id)
        .subscribe((response: any) => {
          this.evaluations_questions = response;
          for (
            let index = 0;
            index < this.evaluations_questions.length;
            index++
          ) {
            this.evaluations_questions[index].response = 0;
          }
        });
    } else {
      this.evaluations_questions = [
        {
          id: 1,
          order: 1,
          question: 'Ponctualité',
          response: 0,
        },
        {
          id: 2,
          order: 2,
          question: 'Amabilité',
          response: 0,
        },
        {
          id: 3,
          order: 3,
          question: 'Présentation',
          response: 0,
        },
        {
          id: 4,
          order: 4,
          question: 'Connaissance du bien',
          response: 0,
        },
      ];
    }
  }

  ariaValueText(current: number, max: number) {
    return `${current} out of ${max} hearts`;
  }

  onSaveQuestion(_comment: string) {
    // store our question length
    let questionLength = this.evaluations_questions.length;
    // tmp object for evalution
    let tmpResponseObjectEvaluation: any = {};
    // our params
    let paramsEvaluation: any = {};
    paramsEvaluation['comment'] = '';
    paramsEvaluation['responses'] = {};
    let isKeysitter = false;
    if (this.typeOfEvaluation != 'keysitter') {
      paramsEvaluation['comment'] = _comment;
      // build our responses params
      for (let i = 0; i < questionLength; i++) {
        paramsEvaluation['responses'][this.evaluations_questions[i].id] =
          this.evaluations_questions[i].response;
      }
    } else {
      isKeysitter = true;
      let paramsKeysitter = [
        'punctuality',
        'kindness',
        'presentation',
        'knowledge',
      ];
      for (let i = 0; i < questionLength.length; i++) {
        paramsEvaluation[paramsKeysitter[i]] =
          this.evaluations_questions[i].response;
      }
      paramsEvaluation['comment'] = _comment;
    }
    this.postDataEvaluation(paramsEvaluation, isKeysitter);
  }

  home() {
    this.modalService.dismissAll();
    void this.router.navigateByUrl('/');
  }

  postDataEvaluation(params: any, isKeysitter: boolean) {
    if (params['comment'] === '' && params['responses'].length === 0) {
      this.emptyReport = true;
    } else {
      this.emptyReport = false;
      let isKeysitterUrl = isKeysitter ? 'keysitter' : 'reports';
      if (isKeysitterUrl == 'keysitter') {
        this._dashboardService
          .evalKeysitter(this.visite.id, params)
          .subscribe((response: any) => {
            if (response.status == 400) {
              this.messageConfirmation = response['message'];
            }
            this.messageConfirmation = 'Message success keyssiter';
            this.showAlert = true;
          });
      } else if (isKeysitterUrl == 'reports') {
        this._dashboardService
          .evalReports(this.visite.id, params)
          .subscribe((response: any) => {
            if (response.status == 400) {
              this.messageConfirmation = response['message'];
            }
            this.messageConfirmation =
              "Le compte-rendu a été transmis au Conseiller THE DOOR MAN en charge du bien que " +
              'vous venez de visiter, qui en fera part à son client vendeur.';
            this.showAlert = true;
            setTimeout(() => {
              void this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                void this.router.navigate([
                  '/espace-personnel/' +
                  UTILS.replaceSpace(this.userConnected.username) +
                  '/tableau-de-bord',
                ]);
              })
            }, 1000);
          });
      }
    }
  }
}
